import { render, staticRenderFns } from "./addServerConfig.vue?vue&type=template&id=7c0778e6&scoped=true&"
import script from "./addServerConfig.vue?vue&type=script&lang=js&"
export * from "./addServerConfig.vue?vue&type=script&lang=js&"
import style0 from "./addServerConfig.vue?vue&type=style&index=0&id=7c0778e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0778e6",
  null
  
)

export default component.exports